var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg32IconMute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2243",
    "data-name": "Group 2243",
    transform: "translate(-199.123 -129.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(199.123 129.317)",
    fill: "#7d6a2d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2242",
    "data-name": "Group 2242",
    transform: "translate(201.24 130.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_volume-mute_",
    "data-name": "FontAwsome (volume-mute)",
    d: "M7.527,64.251,4.413,67.364H.84A.84.84,0,0,0,0,68.2v5.04a.84.84,0,0,0,.84.84H4.413L7.527,77.2A.841.841,0,0,0,8.961,76.6V64.845A.841.841,0,0,0,7.527,64.251Z",
    transform: "translate(5.046 -55.117)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    x2: 7.015,
    transform: "translate(17.758 18.088) rotate(-45)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_309",
    "data-name": "Line 309",
    x2: 7.015,
    transform: "translate(17.758 13.128) rotate(45)",
    fill: "none",
    stroke: "#7d6a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32IconMute);
export default __webpack_public_path__ + "static/media/32-icon-mute.5e5711d4.svg";
export { ForwardRef as ReactComponent };